import React from "react";
import "../styles/why-cloudare.css";
import { PhosphorIcon } from "./PhosphorIcon";

const data = [
  {
    icon: "ShieldCheck",
    title: "Free Post Go-Live Support for 1 Month",
    desc: "Dedicated stabilization support to ensure smooth operations after deployment.",
  },
  {
    icon: "Percent",
    title: "Competitive & Transparent Pricing",
    desc: "No hidden costs — clear, scalable pricing aligned with your business needs.",
  },
  {
    icon: "UsersThree",
    title: "40+ Certified Consultants",
    desc: "ERP, compliance and integration experts with global delivery exposure.",
  },
  {
    icon: "ListChecks",
    title: "100+ Live Implementations",
    desc: "Proven delivery across industries and geographies.",
  },
];

const WhatSetsUsApart = () => {
  return (
    <section className="why-cloudare" style={{ background: "var(--surface)" }}>
      <header className="why-cloudare__header">
        <p className="why-cloudare__eyebrow">Why Cloudare</p>
        <h2 className="why-cloudare__title">What sets us apart</h2>
      </header>
      <div className="why-cloudare__grid">
        {data.map((item, i) => (
          <article className="wc-card" key={i}>
            <div className="wc-card__icon">
              <PhosphorIcon name={item.icon} size={24} />
            </div>
            <h3 className="wc-card__title">{item.title}</h3>
            <p className="wc-card__body">{item.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default WhatSetsUsApart;
